import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { SowService } from '@brafton/atlas-api-client';
import { Feed } from '@brafton/core-api-client';

@Component({
  selector: 'shared-filter-panel-organizations',
  templateUrl: './filter-panel-organizations.component.html',
  styleUrls: ['./filter-panel-organizations.component.scss'],
  host: { class: 'filter-panel-organizations' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SharedFilterPanelOrganizationsComponent implements OnInit {
  @Input() organizations: Filter[] = [];
  @Output() organizationsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  feed!: Feed;
  allFeeds!: Feed[];

  constructor(private sowService: SowService) {}

  ngOnInit() {}

  add(feed: Feed) {
    if (!this.organizations.find((sp) => sp.value === feed.id)) {
      this.organizations.push({ value: feed.id, displayName: feed.name, type: 'organization' } as Filter);
    }
    this.organizationsChange.emit(this.organizations);
  }

  remove(feed: Filter) {
    const index = this.organizations.findIndex((sp) => sp.value === feed.value);
    if (index > -1) {
      this.organizations.splice(index, 1);
    }
    this.organizationsChange.emit(this.organizations);
  }

  clear() {
    this.organizations = [];
    this.organizationsChange.emit(this.organizations);
  }

  isSelected(feed: Feed): boolean {
    if (!this.organizations) return false;
    if (this.organizations.find((sp) => sp.value === feed.id)) return true;
    else return false;
  }
}
